import { render, staticRenderFns } from "./AudienceSection.vue?vue&type=template&id=4cedded8&scoped=true"
import script from "./AudienceSection.vue?vue&type=script&lang=js"
export * from "./AudienceSection.vue?vue&type=script&lang=js"
import style0 from "./AudienceSection.vue?vue&type=style&index=0&id=4cedded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cedded8",
  null
  
)

export default component.exports